import { useAuthStore } from "@utils/stores/authStore.ts";

/**
 * Generate a URL based on the current user's information stored in local storage.
 * @param {string} linkType - The type of link to generate ('invite', 'login', or 'main'). Defaults to 'invite'.
 * @returns {string} The generated URL.
 */
export const getInviteUrl = (
  linkType: "invite" | "login" | "main" = "invite"
) => {
  const { user } = useAuthStore.getState();
  const businessInfo = JSON.parse(localStorage.getItem("businessInfo") ?? "{}");
  const vanitySlug = businessInfo?.vanitySlug;

  if (!user) {
    return "Loading...";
  }
  const storedBusinessId = user.businessId;
  const userId = user.id;
  const firstName = user.firstName;
  const lastName = user.lastName;

  const baseUrl = `${window.location.origin}/${vanitySlug ? vanitySlug : storedBusinessId}`;

  switch (linkType) {
    case "login":
      return `${baseUrl}/login`;
    case "main":
      return baseUrl;
    case "invite":
    default:
      let inviteUrl = `${baseUrl}/register?`;

      if (userId) {
        inviteUrl += `&assigneeId=${userId}`;
      }

      // Add first and last name with fallback values
      inviteUrl += `&firstName=${encodeURIComponent(
        firstName
      )}&lastName=${encodeURIComponent(lastName)}`;

      return inviteUrl;
  }
};
